import { render, staticRenderFns } from "./MedicoCooperado.vue?vue&type=template&id=53502301&"
import script from "./MedicoCooperado.vue?vue&type=script&lang=js&"
export * from "./MedicoCooperado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports